<template>
    <form autocomplete="off" accept-charset="UTF-8" class="filters">
        <input type="hidden" name="scroll" value="stories">
        <div class="filter">
            <label for="story-filter-search">Zoekterm</label>
            <input type="text" id="story-filter-search" name="zoek" placeholder="Zoekterm">
        </div>
        <div class="filter">
            <label for="story-filter-firstName">Voornaam</label>
            <input type="text" id="story-filter-firstName" name="voornaam" placeholder="Marie-Jeanne">
        </div>
        <div class="filter">
            <label for="story-filter-lastname">Familienaam</label>
            <input type="text" id="story-filter-lastname" name="familienaam" placeholder="Boels">
        </div>
        <div class="filter filter--city">
            <input type="hidden" name="postcode" v-model="postcode">
            <input type="hidden" name="stad" v-model="stad">
            <label for="story-filter-city">Gemeente begraafplaats</label>
            <v-select :value="city" :options="cityOptions" @input="setCity" id="story-filter-city" placeholder="Postcode en stad">
                <div slot="no-options">Postcode of stad niet gevonden!</div>
            </v-select>
        </div>
        <div class="filters__submit">
            <input class="btn btn--green" type="submit" value="Zoek">
        </div>
    </form>
</template>

<script>
import cities from '../json/cities.json'
import vSelect from 'vue-select'

export default {
    data() {
        return {
            cityOptions: [],
            city: null,
            cities: cities,
            stad: '',
            postcode: ''
        }
    },
    components: {
        vSelect
    },
    methods: {
        getCityOptions() {
            this.cities.forEach(row => {
                let label = row.zipcode + " " + row.city
                this.cityOptions.push({label: label, zipcode: row.zipcode, city: row.city, county: row.county})
            })
        },
        setCity(val) {
            this.city = val
            this.postcode = val !== null ? val.zipcode : ''
            this.stad = val !== null ? val.city : ''
        }
    },
    mounted() {
        this.getCityOptions()
    }
}
</script>